import React from "react";
import {connect} from "react-redux";

import { FaArrowRightFromBracket } from "react-icons/fa6";

const GlassPane = ({data, children, close, show}) => {

    function closePane(e) {
        close()
    }

    return(
        <div
            style={{
                position: 'fixed',
                top: 100,
                right: show?0:-1000,
                zIndex: 15,
                height: '70vh',
                width: 450,
                background: 'rgba(79,79,79, 0.95)',
                color: 'rgb(197,180,119)',
                transition: 'right 500ms ease-in-out'
            }}
        >
            <div style={{
                background: 'rgb(197,180,119)',
                color: '#4f4f4f',
                cursor: 'default',
                padding: '5px',
                margin: 'auto',
                display: 'flex',
                justifyContent: 'left',
            }} onClick={(e) => closePane(e)}>
                <FaArrowRightFromBracket />
            </div>

            <div style={{
                height: '65vh',
                overflow: 'auto',
                paddingRight: '40px',
            }}>
                {children}
            </div>
        </div>
    )
}

function mapStateToProps(state, other) {
    const ret = state.plan.items ? state.plan.items.filter(
        it => it.typename === "module" && it.scenario === other.uid
    ) : []
    return {modules: ret}
}

export default connect(mapStateToProps)(GlassPane)
